import { Controller } from '@hotwired/stimulus'
import Sortable from 'sortablejs'

export default class extends Controller {
  static targets = ['item', 'handle', 'position']
  static values = {
    url: String,
    param: { type: String, default: 'ids' }
  }

  connect () {
    this.sortable = Sortable.create(this.element, {
      animation: 160,
      easing: 'cubic-bezier(0.2, 0, 0, 1)',
      handle: '[data-sortable-list-target="handle"]',
      draggable: '[data-sortable-list-target="item"]',
      direction: 'vertical',
      ghostClass: 'sortable-ghost',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      // Whole row follows the pointer (native DnD ghost is tiny/jumpy for grid rows).
      forceFallback: true,
      fallbackOnBody: true,
      fallbackClass: 'sortable-fallback',
      fallbackTolerance: 4,
      swapThreshold: 0.65,
      emptyInsertThreshold: 12,
      onStart: (event) => this.lockItemWidth(event.item),
      onEnd: (event) => {
        this.unlockItemWidth(event.item)
        this.persist()
      }
    })
  }

  disconnect () {
    if (this.sortable) {
      this.sortable.destroy()
      this.sortable = null
    }
  }

  lockItemWidth (item) {
    if (!item) return
    const width = item.getBoundingClientRect().width
    item.style.width = `${width}px`
  }

  unlockItemWidth (item) {
    if (!item) return
    item.style.width = ''
  }

  persist () {
    this.refreshPositions()
    if (!this.urlValue) return

    const ids = this.itemTargets.map((item) => item.dataset.id).filter(Boolean)
    const body = new URLSearchParams()
    ids.forEach((id) => body.append(`${this.paramValue}[]`, id))

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'X-CSRF-Token': token || '',
        Accept: 'application/json, text/plain, */*',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body,
      credentials: 'same-origin'
    }).then((response) => {
      if (!response.ok) {
        console.warn('[sortable-list] reorder failed', response.status)
      }
    }).catch((error) => {
      console.warn('[sortable-list] reorder failed', error)
    })
  }

  refreshPositions () {
    this.positionTargets.forEach((el, index) => {
      el.textContent = String(index + 1)
    })
  }
}
